import $ from 'jquery';
import Swiper, {
	Navigation,
	Pagination,
	EffectFade,
	Mousewheel,
} from 'swiper/core';
import LazyLoad from 'vanilla-lazyload';

Swiper.use([Navigation, Pagination, EffectFade, Mousewheel]);

class AcvCarousel {
	constructor(el, settings) {
		this.container = el;
		this.settings = settings;
		this.column = $(this.container).find('.cook-book__column');
		this.image = $(this.container).find('.cook-book__bg');
		this.init();
	}

	init() {
		var lazyImg = new LazyLoad(),
			defaultSettings = {
				on: {
					init: function () {
						// lazyImg.loadAll();
					},
				},
			},
			getSettings = this.settings,
			fullSettings = Object.assign(this.settings, defaultSettings);

		var acv = new Swiper(this.container, fullSettings);

		this.column.each((i, el) => {
			$(el).on('click', () => {
				if ($(window).width() >= 992) {
					acv.slidePrev();
				}
			});
		});

		this.image.each((i, el) => {
			$(el).on('click', () => {
				if ($(window).width() >= 992) {
					acv.slideNext();
				}
			});
		});
	}
}
export default AcvCarousel;
